<template>
  <div class="MyOrder" :style="'width:'+myProductDivWidth+'px;'">
    <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
      <el-tab-pane label="进行中" name="processing">
        <OrderList ref="processingList" :list="pList">&nbsp;</OrderList>
      </el-tab-pane>
      <el-tab-pane label="已完结" name="finished">
        <OrderList ref="finishedList" :list="fList">&nbsp;</OrderList>
      </el-tab-pane>
      <el-tab-pane label="全部订单" name="total">
        <OrderList ref="totalList" :list="tList">&nbsp;</OrderList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    import OrderList from "../components/OrderList"

    export default {
        name: "MyOrder",
        components: {
            OrderList
        },
        data(){
            return{
                myProductDivWidth: document.documentElement.clientWidth - 48,
                unionid: '',
                activeName: 'processing',
                pList: [],
                fList: [],
                tList: []
            }
        },
        methods:{
            handleClick(tab) {
                console.log(tab.paneName);
            },
            dateFormat(date,fmt){
                var o = {
                    "M+": date.getMonth() + 1, //月份
                    "d+": date.getDate(), //日
                    "h+": date.getHours(), //小时
                    "m+": date.getMinutes(), //分
                    "s+": date.getSeconds(), //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    "S": date.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            }
        },
        created() {
            this.unionid = window.localStorage.getItem("fastunionid");
            console.log("我的订单: created(), unionid:",this.unionid);
            this.$axios.get(this.$baseURL + `/incident/list/` + this.unionid)
                .then(data=> {
                    // console.log(data);
                    if(data.data == null){
                        return
                    }
                    for(let j = 0,len=data.data.length; j < len; j++) {
                        // console.log(this.dateFormat(new Date(data.data[j].createTime),"yyyy-MM-dd hh:mm:ss"));
                        // data.data[j].createTime = this.dateFormat(new Date(data.data[j].createTime),"yyyy-MM-dd hh:mm:ss");
                        if(data.data[j].status == "完结" || data.data[j].status == "已回访" || data.data[j].status == "取消"){
                            this.fList.push(data.data[j]);
                        }else {
                            this.pList.push(data.data[j]);
                        }
                        this.tList.push(data.data[j]);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
        }
    }
</script>

<style scoped>
</style>
